<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <g transform="translate(-1300 -141)">
            <circle class="a" cx="19" cy="19" r="19" transform="translate(1300 141)" fill="#383935"/>
            <text class="b" transform="translate(1319.5 167)" fill="#a5d867" font-size="18px" font-family="Museo-Sans" font-weight="700">
                <tspan x="-4.383" y="0">?</tspan>
            </text>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'FaqIcon'
}
</script>

<style scoped>
    svg {
        width:38px;
        height: 38px;
    }
</style>
